// @ts-ignore
const env = process.env.NODE_ENV;
// @ts-ignore
const config = window.runtime_config[env];
export default config;
